export function createFormRenderEvent() {
    return new CustomEvent("d365mkt-formrender", { bubbles: true });
}
